import { pathOr, equals, or } from 'ramda';
import React, { useState } from 'react';
import ProductCard from 'src/components/Card/ProductCard';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { mapIndexed } from 'src/utilities/visualFieldsMapper';
import { isNotEmpty } from 'src/utilities/hasValue';
import ProductFooter from 'src/features/Auth/SignUp/ProductFooter';
import { createMarkup } from 'src/features/utilities';

interface Props {
    options: any;
    title: any;
    displayColumns?: any;
    onHandleSelect: any;
    showCardHorizonal?: any;
    loanType?: string;
}

type CombinedProps = Props;

const ProductTile: React.FC<CombinedProps> = (props: CombinedProps) => {
    const { options, title, displayColumns, onHandleSelect, showCardHorizonal, loanType } = props;

    const [active, setActive] = useState('');
    const onSelect = (product: any) => {
        const update_text = pathOr('', ['value'], product);
        setActive(update_text);
        onHandleSelect(product);
    };
    const { breakpoints } = useTheme();
    const matches = useMediaQuery(breakpoints.down('md'));
    const matchesMd = useMediaQuery(breakpoints.up('md'));
    const matchesLg = useMediaQuery(breakpoints.up('lg'));

    const shouldShowAsGrid = isNotEmpty(displayColumns) && useMediaQuery(breakpoints.up('md'));

    const renderOptions = () => {
        return mapIndexed((_option: any, _index: any) => {
            const product = pathOr('', ['value'], _option);
            return (
                <ProductCard
                    onSelect={onSelect}
                    product={_option}
                    active={equals(active, product)}
                    showCardHorizonal={equals(true, showCardHorizonal)}
                />
            );
        }, options);
    };

    return (
        <Box
            sx={{
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                minHeight: matches ? 'calc(100vh - -8px)' : '45vh',
                pt: matches ? 4 : equals(true, showCardHorizonal) ? matchesMd ? '46px' : 2 : 20,
                alignItems: "center",
                justifyContent: equals(true, showCardHorizonal) && matchesMd ? "flex-start" : "inherit",
                paddingBottom: "24px",
                height: equals(true, showCardHorizonal) && matchesMd ? 'calc(100vh - 135px)' : 'inherit',
                overflowY: 'scroll'
            }}
            pr={2.5}
            pl={matchesLg && equals(true, showCardHorizonal) ? 7.5 : 2.5}
        >
            <Typography
                align="center"
                component="h1"
                variant="h1"
                sx={{
                    paddingBottom: equals(true, showCardHorizonal) ? '38px' : '20px',
                    maxWidth: equals(true, showCardHorizonal) ? 524 : 'inherit',
                    fontSize: equals(true, showCardHorizonal) ? '35px' : 'inherit',
                    lineHeight: equals(true, showCardHorizonal) ? '50px' : 'inherit',
                }}
                mb={matches ? 0 : "39px"}
                dangerouslySetInnerHTML={createMarkup(title)}
            />
            <Box
                sx={{
                    display: or(shouldShowAsGrid, equals(false, showCardHorizonal)) ? 'flex' : 'grid',
                    gridTemplateColumns: or(shouldShowAsGrid, equals(false, showCardHorizonal)) ? `repeat(${displayColumns}, 1fr)` : '',
                    justifyContent: 'center',
                    flexDirection: matches ? 'column' : 'row',
                    width: matches ? '100%' : 'initial',
                    maxWidth: matches ? '100%' : 'initial',
                    alignItems: matches ? 'center' : 'initial',
                    flexWrap: 'wrap'
                }}
            >
                {renderOptions()}
            </Box>
            <ProductFooter loanType={loanType} />
        </Box>
    );
};


export default ProductTile;
